import { useQuickFilters, useTipsheet, useFeatureFlags } from 'hooks';
import getInGridElements from './useInGridElements.utils';

export default function useInGridElements({
    showQuickFilters,
    showTipsheet,
    nbOfProductCards,
    index,
    listingOffset,
    firstPageLength,
}) {
    const [quickFilters] = useQuickFilters();
    const [tipsheet] = useTipsheet();
    const [featureFlags] = useFeatureFlags({
        maxPercentageOfInGridElements:
            'instantSearch.maxPercentageOfInGridElements',
        minHitsLength: 'instantsearch.minHitsLengthForInGridElements',
    });

    return [
        getInGridElements({
            index,
            showQuickFilters: showQuickFilters && quickFilters?.length > 0,
            showTipsheet,
            nbOfProductCards,
            quickFilters,
            tipsheet,
            maxPercentageOfInGridElements:
                featureFlags.maxPercentageOfInGridElements,
            minHitsLength: featureFlags.minHitsLength,
            listingOffset,
            firstPageLength,
        }),
    ];
}
